import { render, staticRenderFns } from "./Courses.html?vue&type=template&id=6042a46a&external"
import script from "./Courses.js?vue&type=script&lang=js&external"
export * from "./Courses.js?vue&type=script&lang=js&external"
import style0 from "./Courses.vue?vue&type=style&index=0&id=6042a46a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports